import React from 'react'
import {connect} from 'react-redux'
import {randomFromArray} from '../../helpers/random-from-array.js'
import store from '../../init/store.js'
import {writeTauntToRoom} from '../connection/firebase-rooms.js'
import {isSubmissionMenuOpen} from './is-submission-menu-open'
import {getIcon} from './SubmissionMenu/icon-svg-getters/icon-categories.js'

const allTaunts = [
  "What are you waiting for?",
  "Hurry up!",
  "Why must you be so slow?",
  "You don't even know what's coming!",
  "Ayyy, batter batter batter!",
  "Is that all you've got?",
  "I thought this was going to be a challenge?",
  "These fingers are going to make you cry!",
  "You got a problem?",
  "Jeez, just pick something.",
  "I'm feeling Dangerous.",
  "Sure you want to do this?"
];

class TauntButton extends React.Component {

  constructor() {
    super();
    this.state = {
      progress: 100
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    if (this.state.progress < 100) {
      //Button not ready
      return;
    }


    //Button is ready!
    //Set firebase taunt:
    const {battlePlayerId, combatants} = store.getState().battle;
    const playerModel = combatants[battlePlayerId[0]];
    const taunt = `${playerModel.name}: ${randomFromArray(allTaunts)}`

    // Write the taunt!
    writeTauntToRoom(taunt);

    //Reset the progress bar
    this.setState({
      progress:0
    }, () => {
      this.fillBar();
    })
  }

  componentDidMount() {
    //this.fillBar();
  }

  fillBar() {
    let step = () => {
      if (this.state.progress < 101) {
        this.setState({
          progress: this.state.progress + 0.5
        }, () => {
          requestAnimationFrame(step)
        })
      }
    };
    requestAnimationFrame(step)
  }

  getWaitingNameText() {

    if (this.props.combatantSelectingAction.length) {

      //Create models for both Player and the Person waiting to select
      const personModel = store.getState().battle.combatants[this.props.arenaSubmissionMenuCombatantIdLock];
      const playerModel = store.getState().battle.combatants[
        store.getState().battle.battlePlayerId[0]
      ];

      //It's possible that the personModel is undefined (end of rally battle?),
      //So just don't show anything here.
      if (!personModel) {
        return null
      }

      //Compare teams to get the correct color for the name text.
      const nameColor = (playerModel.belongsToTeam === personModel.belongsToTeam)
        ? "#4A90E2" //Waiting on person from FRIENDLY team (blue)
        : "#FC304A"; //Waiting on person from ENEMY team (red)

      return (
        <span style={{color: nameColor}}>
          {personModel.name.toUpperCase()}
        </span>
      )
    }

    return <span>somebody</span>
  }


  getPositionStyle(vW) {
    if (this.props.viewportMode === "landscape") {
      return {
        width: vW * 30,
        right:vW * 5,
        bottom: vW * 3,
        fontSize: vW * 3,
      }
    }
    //mobile
    return {
      right:vW * 3,
      left:vW * 3,
      fontSize: vW * 6,
      bottom: vW * 3,
    }
  }

  render() {

    //Taunting is multiplayer only
    if (!this.props.isMultiplayerMode) {
      return null
    }

    if (isSubmissionMenuOpen()) {
      //I'm selecting my option. Focus on that.
      return null
    }

    if (!this.props.arenaSubmissionMenuCombatantIdLock) {
      //Do not show if this person's ID has already been nulled out after submitting
      return null;
    }

    //TODO: for this one, we could maybe check the selectingString instead? but its messy with deadlines and such.
    if (this.props.rolloutData.length !== 0) {
      //I'm reading the rollout text. Focus on that
      return null
    }

    //Get a value for the user to see
    let displayValue = Math.round(this.state.progress);
    displayValue = (displayValue > 100) ? 100 : displayValue; //Floor at 100

    const style = {
      color: displayValue < 100 ? "#666" : "#FCFCFC"
    };

    const iconContainerStyle = {
      display: "block",
      marginRight: "1em"
    };
    const iconCellStyle = {
      boxShadow: "0 0.25em 0 0 rgba(0,0,0,0.3)"
    };

    const messageStyle = {
      padding: "1em 0 1em",
      marginBottom: "1em",
      fontSize: "0.7em",
      lineHeight: "1.7em",
      color: "#FCFCFC",
      borderBottom: "0.3em solid rgba(255,255,255,0.1)"
    };

    //Get the speech bubble icon
    const iconSvg = getIcon("speech", "1.8em");



    /* eslint jsx-a11y/href-no-hash: "off" */
    return (
      <div>
        <div style={messageStyle}>
          Waiting for {this.getWaitingNameText()} to select an action...
        </div>
        <a style={style} className="ArenaSubmissionOption" href="#" onClick={this.handleSubmit.bind(this)}>
          <span style={iconContainerStyle}>
            <span style={iconCellStyle}>
              {iconSvg}
            </span>
          </span>
          <span className="ArenaSubmissionOption-label">
            <span>Taunt!</span>
            <span className="ArenaSubmissionOption-meta">{displayValue}%</span>
          </span>
        </a>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    vW: state.global.vW,
    viewportMode: state.global.viewportMode,

    isMultiplayerMode: state.battle.isMultiplayerMode,

    //So it knows to update...
    arenaSubmissionMenuCombatantIdLock: state.battle.arenaSubmissionMenuCombatantIdLock,
    combatantSelectingAction: state.battle.combatantSelectingAction,
    rolloutData: state.battle.rolloutData
  }
})(TauntButton)


// WEBPACK FOOTER //
// ./src/battle/ArenaView/TauntButton.js